var _excluded = ["normalizedItems", "showItemIcons", "tooltip", "selectedKeys", "defaultSelectedKeys", "disabledKeys", "onChange", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useMemo } from 'react';
import { Section } from '@adobe/react-spectrum';
import { getItemKey, isNormalizedSection, normalizeTooltipOptions, useRenderNormalizedItem, useStringifiedMultiSelection } from "../utils/index.js";
/** Props that are derived by `useMultiSelectNormalizedProps` */
/**
 * Props that are passed through untouched. Should exclude all of the
 * destructured props passed into `useMultiSelectNormalizedProps` that are not
 * in the spread `...props`.
 */
/** Props returned from `useMultiSelectNormalizedProps` hook. */
import { jsx as _jsx } from "react/jsx-runtime";
export function useMultiSelectNormalizedProps(_ref) {
  var normalizedItems = _ref.normalizedItems,
    showItemIcons = _ref.showItemIcons,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? true : _ref$tooltip,
    selectedKeys = _ref.selectedKeys,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    disabledKeys = _ref.disabledKeys,
    onChange = _ref.onChange,
    onSelectionChange = _ref.onSelectionChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var tooltipOptions = useMemo(() => normalizeTooltipOptions(tooltip), [tooltip]);
  var renderNormalizedItem = useRenderNormalizedItem({
    itemIconSlot: 'icon',
    showItemDescriptions: false,
    showItemIcons,
    tooltipOptions
  });

  // Spectrum doesn't re-render if only the render function identity changes,
  // so we expose a key that the parent can use to force a re-render.
  var forceRerenderKey = "".concat(showItemIcons, "-").concat(tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.placement);

  // Stringification operates on the flat item list so selection works for
  // items inside sections too.
  var flatItems = useMemo(() => normalizedItems.flatMap(item => {
    var _item$item$items, _item$item;
    return isNormalizedSection(item) ? (_item$item$items = (_item$item = item.item) === null || _item$item === void 0 ? void 0 : _item$item.items) !== null && _item$item$items !== void 0 ? _item$item$items : [] : [item];
  }), [normalizedItems]);
  var _useStringifiedMultiS = useStringifiedMultiSelection({
      normalizedItems: flatItems,
      selectedKeys,
      defaultSelectedKeys,
      disabledKeys,
      onChange: onChange !== null && onChange !== void 0 ? onChange : onSelectionChange
    }),
    selectedStringKeys = _useStringifiedMultiS.selectedStringKeys,
    defaultSelectedStringKeys = _useStringifiedMultiS.defaultSelectedStringKeys,
    disabledStringKeys = _useStringifiedMultiS.disabledStringKeys,
    onStringSelectionChange = _useStringifiedMultiS.onStringSelectionChange;
  var children = useMemo(() => normalizedItems.map(itemOrSection => {
    if (isNormalizedSection(itemOrSection)) {
      var _itemOrSection$item, _itemOrSection$item2;
      return /*#__PURE__*/_jsx(Section, {
        title: (_itemOrSection$item = itemOrSection.item) === null || _itemOrSection$item === void 0 ? void 0 : _itemOrSection$item.title,
        items: (_itemOrSection$item2 = itemOrSection.item) === null || _itemOrSection$item2 === void 0 ? void 0 : _itemOrSection$item2.items,
        children: renderNormalizedItem
      }, getItemKey(itemOrSection));
    }
    return renderNormalizedItem(itemOrSection);
  }), [normalizedItems, renderNormalizedItem]);
  return _objectSpread(_objectSpread({}, props), {}, {
    children,
    forceRerenderKey,
    selectedKeys: selectedStringKeys,
    defaultSelectedKeys: defaultSelectedStringKeys,
    disabledKeys: disabledStringKeys,
    onChange: onStringSelectionChange
  });
}
export default useMultiSelectNormalizedProps;
//# sourceMappingURL=useMultiSelectNormalizedProps.js.map